import React from "react";
import DatePicker from "react-datepicker";
import Input from "../../../../../components/inputs/input";
import Select from "../../../../../components/selects/select";
import CheckboxField from "../field/checkbox/checkbox";
import CollapsedSelect from "../field/collapsed-select/collapsed-select";
import MultiInputField from "../field/multi-input/multi-input";
import RangeField from "../field/range/range";
import RangeBetweenField from "../field/range-between/range-between";
import SwitchField from "../field/switch/switch";
import TextAreaField from "../field/text-area/text-area";

const dateMask = [
	/\d/, /\d/, "/",
	/\d/, /\d/, "/",
	/\d/, /\d/, /\d/, /\d/
];

export const formFieldComponents = {
	select: {
		component: Select,
		getProps: ({
			field,
			value,
			fieldClassName,
			handleFieldChange
		}) => ({
			className: fieldClassName,
			name: field.name,
			label: field.label,
			value,
			itens: field.options,
			onChange: handleFieldChange,
			placeholder: field.placeholder,
			required: field.required === true,
			width: "100%",
			disabled: field.disabled
		})
	},

	collapseSelect: {
		component: CollapsedSelect,
		getProps: ({
			field,
			value,
			error,
			handleFieldChange,
			handleFieldBlur
		}) => ({
			name: field.name,
			label: field.label,
			value,
			options: field.options,
			placeholder: field.placeholder,
			disabled: field.disabled,
			error: Boolean(error),
			onChange: handleFieldChange,
			onBlur: handleFieldBlur
		})
	},

	date: {
		component: DatePicker,
		getProps: ({
			field,
			value,
			fieldClassName,
			handleFieldChange
		}) => ({
			className: fieldClassName,
			locale: "pt",
			name: field.name,
			id: field.id,
			placeholder: field.placeholder,
			dateFormat: "dd/MM/yyyy",
			selected: value,
			onChange: handleFieldChange,
			autoComplete: "off",
			customInput: (
				<Input
					className={fieldClassName}
					type="text"
					label={field.label}
					mask={dateMask}
					width="100%"
				/>
			)
		})
	},

	checkbox: {
		component: CheckboxField
	},

	"multi-input": {
		component: MultiInputField
	},

	range: {
		component: RangeField
	},

	rangeBetween: {
		component: RangeBetweenField
	},

	switch: {
		component: SwitchField
	},

	textarea: {
		component: TextAreaField
	}
};

export const getFormFieldConfig = type => {
	return formFieldComponents[type] || null;
};